import React, { useEffect, useState } from "react";
import { listTaskSources, reviewTaskSource, updateTaskSource } from "./api";
import { TASK_SOURCE_ROLES, taskSourceClaimText, taskSourceStatusLabel } from "./taskSourceCopy";

export default function TaskSourcesPanel({ repoId, featurePlanId }) {
  const [artifacts, setArtifacts] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!repoId || !featurePlanId) return;
      try {
        const next = await listTaskSources({ repoId, featurePlanId });
        if (!cancelled) setArtifacts(Array.isArray(next) ? next : []);
      } catch (err) {
        if (!cancelled) setError(err?.message || "Could not load screenshots.");
      }
    }
    void load();
    return () => {
      cancelled = true;
    };
  }, [repoId, featurePlanId]);

  if (!repoId || !featurePlanId) return null;

  return (
    <aside className="task-sources-panel" data-testid="task-sources-panel">
      <h4>Sources</h4>
      {error ? <p className="wbg-hint">{error}</p> : null}
      {artifacts.length === 0 ? (
        <p className="wbg-hint">No screenshots attached to this Task.</p>
      ) : (
        <ul className="task-sources-list">
          {artifacts.map((artifact) => (
            <li key={artifact.artifactId} className="task-source-card">
              <strong className="task-source-filename">{artifact.originalFilename || "Screenshot"}</strong>
              <span className="task-source-status">{taskSourceStatusLabel(artifact.processingState)}</span>
              <select
                value={artifact.declaredRole || "unspecified"}
                aria-label={`Label for ${artifact.originalFilename}`}
                onChange={async (event) => {
                  const next = await updateTaskSource({
                    repoId,
                    artifactId: artifact.artifactId,
                    declaredRole: event.target.value,
                  });
                  setArtifacts((prev) =>
                    prev.map((item) => (item.artifactId === next.artifactId ? next : item))
                  );
                }}
              >
                {TASK_SOURCE_ROLES.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.label}
                  </option>
                ))}
              </select>
              {artifact.extractionResult?.summary ? <p>{artifact.extractionResult.summary}</p> : null}
              {(artifact.extractionResult?.candidateRequirements || []).map((claim, index) => (
                <div key={`${artifact.artifactId}-${index}`}>
                  <p>{taskSourceClaimText(claim)}</p>
                  <button
                    type="button"
                    onClick={async () => {
                      const next = await reviewTaskSource({
                        repoId,
                        artifactId: artifact.artifactId,
                        observationKey: `candidateRequirements:${index}`,
                        action: "confirm",
                      });
                      setArtifacts((prev) =>
                        prev.map((item) => (item.artifactId === next.artifactId ? next : item))
                      );
                    }}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    onClick={async () => {
                      const next = await reviewTaskSource({
                        repoId,
                        artifactId: artifact.artifactId,
                        observationKey: `candidateRequirements:${index}`,
                        action: "example",
                      });
                      setArtifacts((prev) =>
                        prev.map((item) => (item.artifactId === next.artifactId ? next : item))
                      );
                    }}
                  >
                    Example only
                  </button>
                </div>
              ))}
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
